<template>
   <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        
        <span class="headline">{{ modo == "editar" ? 'Editar tipo de tratamiento' : 'Crear tipo de tratamiento' }}</span>
      </v-card-title>
    <v-card-text>
      <v-form ref="form" @keypress="handleEnter" v-model="valid">
        <v-container>
          <v-row>
            <v-col cols="12" class="custom-col">
              <v-text-field v-model="tipo_tratamiento.name" :rules="[v => !!v || 'Nombre de la tipo tratamiento requerido']"
                label="Nombre del tipo tratamiento" required></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="cancel">Cancelar</v-btn>
        <v-btn color="green darken-1" text :disabled="!valid" @click="submit">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </template>


<script>
export default {
  name: 'FormularioFrecuencia',

  data() {
    return {
      valid: false,
      dialog: true,
      tipo_tratamiento: {
        name: '',
      },
    };
  },

  props: {
    tipo_tratamientoEntrada: {
      type: Object,
      default: () => ({
        name: '',
      })
    },
    modo: String
  },

  watch: {
  tipo_tratamientoEntrada: {
    immediate: true,
    handler(newVal) {
      this.tipo_tratamiento = Object.assign({}, newVal);
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.resetValidation();
        });
      }
    }
  }
},


  methods: {
    handleEnter(event) {
      console.log("enterrr")
      console.log(event.key)
      if (event.key === 'Enter') {
        event.preventDefault(); // Evita que el formulario se envíe al presionar Enter
        this.submit();
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        // Enviar datos
        this.close();

      }
    },

    close() {
      console.log("closeeeeeee")
      this.$emit('close', this.tipo_tratamiento);
    },

    cancel() {
      console.log("cancelandooooo")
      this.$emit('cancel');
    }

  },
};
</script>

<style scoped>
.custom-col {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
